import AddIcon from "@mui/icons-material/AddRounded";
import ExportIcon from "@mui/icons-material/OutputRounded";
import { Button, Stack } from "@mui/material";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import MembersContext from "../../MembersContext";

const MembersGridActionsBar = () => {
  const {
    hasAccessToManageOrganizationUsers,
    filters,
    openInviteMembersDialog,
    isLoading,
    exportToCsv,
    members,
    filteredMembers,
  } = useDefinedContext(MembersContext);

  const disableExportToCsv =
    isLoading || members.length === 0 || (filteredMembers.length === 0 && filters.search.trim() !== "");

  if (!hasAccessToManageOrganizationUsers) {
    return null;
  }

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
      <Button
        sx={{ whiteSpace: "nowrap" }}
        disabled={disableExportToCsv}
        onClick={exportToCsv}
        variant="outlined"
        startIcon={<ExportIcon />}
      >
        Export to CSV
      </Button>
      <Button
        sx={{ whiteSpace: "nowrap" }}
        onClick={openInviteMembersDialog}
        variant="contained"
        startIcon={<AddIcon />}
      >
        Invite Members
      </Button>
    </Stack>
  );
};

export default MembersGridActionsBar;
